import {
  Action,
  combineReducers,
  createFeatureSelector,
  createSelector,
} from '@ngrx/store';
import * as fromVehicle from './vehicles-detail.reducer';
import * as fromMaintenanceNotes from './maintenance-note.reducer';
import * as fromMaintenanceSchedule from './maintenance-schedule.reducer';
import * as fromVehiclePhotos from './vehicle-photo.reducer';
import * as fromEngineLight from './vehicle-diagnostics.reducer';

export const vehiclesFeatureKey = 'vehiclesModuleStore';

export interface State {
  [fromVehicle.vehiclesDetailFeatureKey]: fromVehicle.State;
  [fromMaintenanceNotes.maintenanceNoteFeatureKey]: fromMaintenanceNotes.State;
  [fromMaintenanceSchedule.maintenanceScheduleFeatureKey]: fromMaintenanceSchedule.State;
  [fromVehiclePhotos.vehiclePhotoFeatureKey]: fromVehiclePhotos.State;
  [fromEngineLight.getVehicleDiagnosticsFeatureKey]: fromEngineLight.State;
}

export function reducers(state: State | undefined, action: Action) {
  return combineReducers({
    [fromVehicle.vehiclesDetailFeatureKey]: fromVehicle.reducer,
    [fromMaintenanceNotes.maintenanceNoteFeatureKey]:
      fromMaintenanceNotes.reducer,
    [fromMaintenanceSchedule.maintenanceScheduleFeatureKey]:
      fromMaintenanceSchedule.reducer,
    [fromVehiclePhotos.vehiclePhotoFeatureKey]: fromVehiclePhotos.reducer,
    [fromEngineLight.getVehicleDiagnosticsFeatureKey]: fromEngineLight.reducer,
  })(state, action);
}

export const getVehiclesState =
  createFeatureSelector<State>(vehiclesFeatureKey);

export const selectVehicleState = createSelector(
  getVehiclesState,
  (state: State) => state[fromVehicle.vehiclesDetailFeatureKey],
);

export const getMaintenanceScheduleState = createSelector(
  getVehiclesState,
  (state: State) =>
    state[fromMaintenanceSchedule.maintenanceScheduleFeatureKey],
);
export const getVehiclePhotosState = createSelector(
  getVehiclesState,
  (state: State) => state[fromVehiclePhotos.vehiclePhotoFeatureKey],
);

export const getVehicleDiagnosticsState = createSelector(
  getVehiclesState,
  (state: State) => state[fromEngineLight.getVehicleDiagnosticsFeatureKey],
);
